<template>
  <div class="wrapper">
    <div class="bg-box">
      <div class=""></div>
      <div class="comment-box">
        <div class="image-box">
          <img src="https://ssqs-1304047091.cos.ap-guangzhou.myqcloud.com/resource/hp/h5-comment-flow.png" alt="" class="comment-img">
        </div>

        <div class="discuss-box">

          <div class="content">
            <div class="tabs-head">
              <div class="tips-tab">
                <img src="https://ssqs-1304047091.cos.ap-guangzhou.myqcloud.com/resource/hp/h5-tips-tabs.png" alt="" class="tab-img">
              </div>
              <div class="label">好评文案</div>
              <div class="value">
                <div class="btn-copy-save" @click="copyText" v-if="commentText">
                  复制评论
                </div>
              </div>
            </div>

            <div class="discuss-item">
              <div class="text">{{commentText}}</div>
            </div>
          </div>

        </div>

      </div>

    </div>
  </div>
</template>
<script>
import {getComment} from "../request/api";
import {Toast} from "mint-ui";

export default {
  name: 'CommentPage',
  components: {
  },
  data () {
    return {
      commentText:'',           //定义评论文案

    }
  },
  created(){

  },
  mounted() {
    this.getCommentData();
  },
  methods:{

    getCommentData(){
      getComment().then((res)=>{
        do{
          if(res.code !==0){
            Toast({
              message: res.msg,
              duration: 2000,
            });
            break
          }
          this.commentText = res.data.info.text;
        }while (false)
      }).catch(()=>{

      })
    },

    copyText() {
      this.$copyText(this.commentText).then(() => {
        alert("复制成功！");//弹出提示信息
        // 复制成功的操作
      }, () => {
        alert("复制失败！");//弹出提示信息
        // 复制失败的操作
      });
    },

  }

}
</script>
<style lang="less">
.wrapper{
  width: 100%;
  height: 100vh;
  background: #8BDE94;
  .bg-box{
    width: 100%;
    min-height: 100%;
    background: url("https://ssqs-1304047091.cos.ap-guangzhou.myqcloud.com/resource/hp/h5-bg-comment.png") no-repeat;
    background-size: 100% auto;
    box-sizing: border-box;
    padding: 0 20px 50px 20px;
    position: fixed;
    left: 0;
    top:0;
  }
  .comment-box{
    width: 100%;
    margin-top: 343px;
    .image-box{
      width: 100%;
      .comment-img{
        width: 100%;
      }
    }

    .discuss-box{
      width: 100%;
      margin-top: 15px;
      box-sizing: border-box;
      padding: 5px;
      color: #333333;
      background: #FDFFFF;
      border-radius: 10px;
      .content{
        border-radius: 10px;
        width: 100%;
        background: #FFFFFF;
        box-sizing: border-box;
        padding: 0 10px;
        .tabs-head{
          width: 100%;
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          align-items: center;
          position: relative;
          .tips-tab{
            position: absolute;
            left:72px;
            top:-20px;
            .tab-img{
              width: 120px;
            }
          }
          .label{
            font-size: 17px;
            font-weight: 600;
            color: #8A0F02;
          }
          .value{
            .btn-copy-save{
              padding: 0 15px;
              height: 32px;
              line-height: 32px;
              border-radius: 16px;
              font-size: 13px;
              text-align: center;
              color: #ffffff;
              background: #FD9F0B;
            }
          }
        }
        .discuss-item{
          margin-bottom: 15px;
          .text{
            font-size: 14px;
            margin: 10px 0;
            color: #D1A19A;
          }
        }
      }
    }

  }
}

</style>




// WEBPACK FOOTER //
// src/page/comment.vue